import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query PressPostQuery {
      allStoryblokEntry(filter: { lang: { eq: "default" }, field_component: { eq: "pressPost" } }) {
        nodes {
          name
          full_slug
          content
          published_at
          # published_at(formatString: "MMMM d, YYYY")
        }
      }
    }
  `);

  const pressPosts = allStoryblokEntry.nodes.map((post) => {
    return {
      ...post,
      content: JSON.parse(post.content),
    };
  });

  return pressPosts;
};
